import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import Fourth from "./Fourth_section/Fourth";
import Fifth from "./Fifth_section/Fifth";
import Sixth from "./Sixth_section/Sixth";
import Seventh from "./Seventh_section/Seventh";
import Ourclient from "../../Home/Ourclientword/Ourclient";
import Last from "./Last_section/Last";

const MobileApp = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
      <Sixth />
      <Seventh />
      <Ourclient />
      <Last />
      <Footer />
    </>
  );
};

export default MobileApp;
